import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IssueSubmissionResponse, PolicyCarChangeRequest, PolicyChangePaymentRequest, PolicyChangeQuoteResponse } from '../models';

@Injectable({
    providedIn: 'root'
})
export class PolicyChangeService {
    constructor(private http: HttpClient) { }

    issuePaymentMethod(payload: PolicyChangePaymentRequest) {
        return this.http.post(`${environment.server.api.portalpas}/policy/issue-policy-change-for-payment-method`, payload);
    }

    setCarChange(policyCarChangeRequest: PolicyCarChangeRequest) {
        const endpoint = `${environment.server.api.portalpas}/policy/car-change/${policyCarChangeRequest.policyPeriodId}`;
        return this.http.put(endpoint, policyCarChangeRequest);
    }

    createPolicyChange(policyPeriodId: string, effectiveDate: Date) {
        const payload = {
            policyPeriodId: policyPeriodId,
            effectiveDate: effectiveDate
        };

        const endpoint = `${environment.server.api.portalpasProxy}/policycenter-policy/api/Policies/${policyPeriodId}/generate-change`;

        return this.http.post(endpoint, payload)
            .pipe(
                map((response: any) => {
                    if (response.id) {
                        return response.id
                    } else {
                        return response;
                    }
                })
            );
    }

    policyChangeQuote(policyPeriodId: string, getSummary: boolean = true): Observable<PolicyChangeQuoteResponse> {
        return this.http.get<PolicyChangeQuoteResponse>(`${environment.server.api.portalpas}/Policy/${policyPeriodId}/quote?getSummary=${getSummary}`);
    }

    issueSubmission(jobNumber: string, branchNumber: number) {
        return this.http.post<IssueSubmissionResponse>(`${environment.server.api.portalpas}/Policy/issue-submission`, {
            jobNumber: jobNumber,
            branchNumber: branchNumber,
            warningsThrowException: false
        });
    }
    
}
